import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addBlogsFailure,
  //
  addBlogsSuccess,
  deleteBlogsFailure,
  //
  deleteBlogsSuccess,
  editBlogsFailure,
  //
  editBlogsSuccess,
  fetchBlogsFailure,
  fetchBlogsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_BLOGS,
  DELETE_BLOGS,
  EDIT_BLOGS,
  FETCH_BLOGS,
  GET_VIEW_DATA,
} from "./constants";
import { setBlogFetchter } from "../Filter/actions";

export function* fetchBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location-blog?${query}`);
    yield put(fetchBlogsSuccess(data));
    yield put(setBlogFetchter(true));
  } catch (e) {
    yield put(fetchBlogsFailure());
    yield put(setBlogFetchter(true));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching blog!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-blog/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching blog!"));
  }
}

export function* addBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const location = yield select(
    (state) => state?.SlickCareProfilesReducer?.activeLocation
  );
  try {
    const data = yield call(
      api(token).post,
      `/api/location-blog/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Blog added successfully!"));
      yield put(addBlogsSuccess());
      if (payload?.history) {
        payload.history.push(`/d/location/edit/${location?.id}/posts`);
      }
    }
  } catch (e) {
    yield put(addBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location-blog/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Blog updated successfully!"));
      yield put(editBlogsSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteBlogsSaga({ payload, onDeleteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/location-blog/${payload}`);
    if (data) {
      yield put(successAlert("Blog deleted successfully!"));
      yield put(deleteBlogsSuccess());
      typeof onDeleteSuccess === "function" && onDeleteSuccess();
    }
  } catch (e) {
    yield put(deleteBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchBlogsFlow() {
  yield takeEvery(FETCH_BLOGS, fetchBlogsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addBlogsFlow() {
  yield takeEvery(ADD_BLOGS, addBlogsSaga);
}
export function* editBlogsFlow() {
  yield takeEvery(EDIT_BLOGS, editBlogsSaga);
}
export function* deleteBlogsFlow() {
  yield takeEvery(DELETE_BLOGS, deleteBlogsSaga);
}
export default function* BlogsSaga() {
  yield all([
    fetchBlogsFlow(),
    addBlogsFlow(),
    editBlogsFlow(),
    deleteBlogsFlow(),
    getViewDataFlow(),
  ]);
}
